import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { IProjectContract } from 'src/app/project-display/interfaces/IProjectContract';
import { IProjectSummary } from 'src/app/project-display/interfaces/IProjectSummary';



@Component({
  selector: 'eic-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['../../../project-display.styles.scss',
              './contract.component.scss']
})
export class ContractComponent {
  @Input() contract: IProjectContract;
  @Input() stage: string;
  @Input() currentProject: { id: number, name: string };
  @Output() contract_selected = new EventEmitter();
  @Output() project_selected = new EventEmitter();

  @ViewChild(MatExpansionPanel) panel: MatExpansionPanel;

  isExpanded: boolean = false;
  


  searchTerm: any;
  toggleContractExpanded() {
    if (this.isExpanded) {
      this.close()
    }
    else {
      this.open()
    }
  }

  open() {
    this.isExpanded = true;
    this.panel.open();
  }

  close() {
    this.isExpanded = false;
    this.panel.close();
  }

  // Navigate to the contract
  openContract(contract) {
    this.contract_selected.emit(contract);
  }

  openProject(project:IProjectSummary) {
    this.project_selected.emit(project);
  } 

}
